export default __webpack_public_path__ + "static/laptop-xs-0c9fabfee14159320b8732d4a5b23b2e.webp";